import React from "react";
import { AccessibilityHiddenImg } from '@skillz/accessibility';
import classes from "./HeaderPopup.module.css"

const HeaderPopup = ({ color, title, icon }) => {

    return (
        <div className={classes.HeaderPopup} style={{ background: color }}>
            <p className={classes.Title}>{title}</p>
            {icon && <AccessibilityHiddenImg src={icon} />}
        </div>
    )
}

export default HeaderPopup;